//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    isShown: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    fullImage: {
      type: Object,
      default: () => {
        return {
          url: '',
          img: ''
        }
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('cancel')
    }
  }
}
